import React from "react";
import { subscriptionColumnsConfig } from "../config/Subscriptions";

const formatCurrency = (amount, currency) => {
  if (amount === null || amount === undefined) {
    return "-";
  }

  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: (currency || "USD").toUpperCase(),
      minimumFractionDigits: 2,
    }).format(amount);
  } catch (error) {
    return `${currency || "USD"} ${amount}`;
  }
};

const badgeClassMap = {
  active: "badge-soft-success",
  paid: "badge-soft-success",
  canceled: "badge-soft-danger",
  past_due: "badge-soft-warning",
  unpaid: "badge-soft-danger",
};

const getBadgeClass = (status) => {
  if (!status) return "badge-soft-secondary";
  return badgeClassMap[status.toLowerCase()] || "badge-soft-secondary";
};

export const getSubscriptionColumns = ({ onDownloadInvoice } = {}) => {
  return [
    {
      name: (
        <span className="font-weight-bold fs-13">
          {subscriptionColumnsConfig.EMAIL}
        </span>
      ),
      selector: (row) => row.user_email || row.email || "-",
      sortable: true,
      cell: (row) => (
        <span 
          title={row.user_email || row.email}
          onClick={(e) => e.stopPropagation()} // Prevent row click when clicking email
        >
          {row.user_email || row.email || "-"}
        </span>
      ),
    },
    {
      name: (
        <span className="font-weight-bold fs-13">
          {subscriptionColumnsConfig.AMOUNT}
        </span>
      ),
      selector: (row) => row.amount || row.invoice_amount_paid || 0,
      sortable: true,
      cell: (row) => (
        <span onClick={(e) => e.stopPropagation()}> {/* Prevent row click */}
          {formatCurrency(
            row.invoice_amount_paid ?? row.amount ?? 0,
            row.currency || row.invoice_currency
          )}
        </span>
      ),
    },
    {
      name: (
        <span className="font-weight-bold fs-13">
          {subscriptionColumnsConfig.STATUS}
        </span>
      ),
      selector: (row) => row.status || row.invoice_status || "-",
      sortable: true,
      cell: (row) => (
        <span 
          className={`badge ${getBadgeClass(row.status || row.invoice_status)}`}
          onClick={(e) => e.stopPropagation()} // Prevent row click
        >
          {(row.status || row.invoice_status || "-").toUpperCase()}
        </span>
      ),
    },
    {
      name: (
        <span className="font-weight-bold fs-13">
          {subscriptionColumnsConfig.PAYMENT_TYPE}
        </span>
      ),
      selector: (row) => row.payment_method_type || row.payment_type || "-",
      cell: (row) => (
        <span onClick={(e) => e.stopPropagation()}> {/* Prevent row click */}
          {(row.payment_method_type || row.payment_type || "-")
            .toString()
            .toUpperCase()}
        </span>
      ),
    },
    {
      name: (
        <span className="font-weight-bold fs-13">
          {subscriptionColumnsConfig.SUBSCRIPTION_TYPE}
        </span>
      ),
      selector: (row) => row.plan_label || row.plan_type || "-",
      sortable: true,
      cell: (row) => (
        <span onClick={(e) => e.stopPropagation()}> {/* Prevent row click */}
          {row.plan_label || row.plan_type || "-"}
        </span>
      ),
    },
    {
      name: (
        <span className="font-weight-bold fs-13">
          {subscriptionColumnsConfig.CREATED}
        </span>
      ),
      selector: (row) => row.createdAt || "-",
      sortable: true,
      cell: (row) => (
        <span onClick={(e) => e.stopPropagation()}> {/* Prevent row click */}
          {row.createdAt || "-"}
        </span>
      ),
    },
    {
      name: (
        <span className="font-weight-bold fs-13">
          {subscriptionColumnsConfig.ACTIONS}
        </span>
      ),
      sortable: false,
      width: "140px",
      cell: (row) => {
        const hasInvoice = Boolean(row.invoice_pdf || row.hosted_invoice_url);
        return (
          <button
            type="button"
            className="btn action-button"
            disabled={!hasInvoice}
            style={{border: 'none'}}
            onClick={(event) => {
              event.stopPropagation(); // Prevent row click
              if (hasInvoice && onDownloadInvoice) {
                onDownloadInvoice(row);
              } else if (hasInvoice) {
                const url = row.invoice_pdf || row.hosted_invoice_url;
                window.open(url, "_blank");
              }
            }}
          >
            <i className="ri-download-2-line rounded-circle shadow-sm bg-f1 p-2 text-primary" />
          </button>
        );
      },
    },
  ];
};